export const REQUEST_EVENT_DATA = "REQUEST_EVENT_DATA";
export const OPERATION_ERROR = "OPERATION_ERROR";
export const RECEIVE_EVENT_DATA = "RECEIVE_EVENT_DATA";
export const RECEIVE_GLOBALISATION = "RECEIVE_GLOBALISATION";
export const REQUEST_GLOBALISATION = "REQUEST_GLOBALISATION";
export const REQUEST_DOWNLOAD_FILE = "REQUEST_DOWNLOAD_FILE";
export const RECEIVE_DOWNLOAD_FILE = "RECEIVE_DOWNLOAD_FILE";
export const SHOW_PROGRESS = "SHOW_PROGRESS";
export const REQUEST_URLS = "REQUEST_URLS";
export const RECEIVE_URLS = "RECEIVE_URLS";
export const RECEIVE_URLS_ERROR = "RECEIVE_URLS_ERROR";
export const RECEIVE_GENERATEDMESSAGE_DATA = "RECEIVE_GENERATEDMESSAGE_DATA";
export const REQUEST_GENERATEDMESSAGE_DATA = "REQUEST_GENERATEDMESSAGE_DATA";






